import React, { useEffect } from 'react'
import MuiDuration from '@zuto/molecules/src/Mui/Duration/MuiDuration'
import LengthOfTimeEntry from './LengthOfTimeEntry'
import withFade from '../HOC/withFade'
import { fireReactGAEvent, scrollToTheTop } from '../Questions/utils'

interface LengthOfTimeProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'defaultValue'> {
  valueChanged?: (_: Record<string, unknown>) => void
  onKeyPress: (event: React.KeyboardEvent) => void
  defaultValue?: LengthOfTimeEntry
  error?: {
    message?: string,
    fields: string[]
  }
  trackingLabel?: string
}

const LengthOfTime = ({
  children,
  valueChanged,
  onKeyPress,
  defaultValue,
  error,
  trackingLabel
}: LengthOfTimeProps): JSX.Element => {
  useEffect(() => {
    if (trackingLabel) {
      fireReactGAEvent({
        category: 'Application Form',
        action: 'Question Visible',
        label: trackingLabel,
        nonInteraction: true
      })
    }
  }, [])

  useEffect(scrollToTheTop, [])

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (valueChanged) {
      const { name, value } = e.currentTarget
      valueChanged({ [name]: value })
    }
  }

  return (
    <>
      {children}
      <MuiDuration
        onChange={onChange}
        onKeyPressHandler={onKeyPress}
        defaultValue={defaultValue as Record<string, string | undefined>}
        error={error}
      />
    </>
  )
}

export default withFade(LengthOfTime)
